import * as goldenrush from './Aside.styles.goldenrush';
import * as juicybet from './Aside.styles.juicybet';
import * as puntcity from './Aside.styles.puntcity';
import * as sterlingparker from './Aside.styles.sterlingparker';
import * as vikingbet from './Aside.styles.vikingbet';
import * as forsport from './Aside.styles.forsport';
import * as junglebet from './Aside.styles.junglebet';
import * as oldgill from './Aside.styles.oldgill';
import * as sugarcastle from './Aside.styles.sugarcastle';
import * as buffalobet from './Aside.styles.buffalobet';
import * as titanbet from './Aside.styles.titanbet';
import * as bet777 from './Aside.styles.bet777';
import * as gigabet from './Aside.styles.gigabet';
import * as slambet from './Aside.styles.slambet';
import * as betstride from './Aside.styles.betstride';
import * as templebet from './Aside.styles.templebet';
import * as goldenbet888 from './Aside.styles.goldenbet888';
import * as hyperbet from './Aside.styles.hyperbet';
import * as chromabet from './Aside.styles.chromabet';
import * as bet575 from './Aside.styles.bet575';
import * as epicodds from './Aside.styles.epicodds';
import * as pyramidbet from './Aside.styles.pyramidbet';
import * as magnumbet from './Aside.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
